import {Base} from "../Base";

/**
 * A factory to get fetchers
 * @extends Base
 * @hideconstructor
 */
class FetcherFactory extends Base {

    getClassName() {
        return "FetcherFactory";
    }

    getFetcher(url){
        return new Fetcher(url);
    }
}

/**
 * A class that isolates fetching data from a URL
 * @extends Base
 */
class Fetcher extends Base{

    getClassName() {
        return "Fetcher";
    }

    /**
     *
     * @param url {string} The url to fetch data for
     */
    constructor(url) {
        super();
        this.url = url;
        this.successCallbacks = new Set();
        this.errorCallbacks = new Set();
        this.alwaysCallbacks = new Set();
    }

    logDebug(msg, obj = undefined) {
        super.logDebug('['+this.url.crop(75)+']\t'+msg, obj);
    }

    logInfo(msg, obj = undefined) {
        super.logInfo('['+this.url.crop(75)+']\t'+msg, obj);
    }

    logError(msg, obj = undefined) {
        super.logError('['+this.url.crop(75)+']\t'+msg, obj);
    }

    /**
     * Fetches data from the URL
     * clears all callbacks in the end
     * @return {Fetcher}
     */
    fetch(){
        return this._fetch(false, false);
    }

    /**
     * Fetches JSON data from the URL
     * clears all callbacks in the end
     * @return {Fetcher}
     */
    fetchJSON(){
        return this._fetch(true, false);
    }
    /**
     * Fetches data from the URL
     * clears all callbacks in the end
     * @return {Promise}
     */
    fetchPromise(){
        return this._fetch(false, true);
    }

    /**
     * Fetches JSON data from the URL
     * clears all callbacks in the end
     * @return {Promise}
     */
    fetchJSONPromise(){
        return this._fetch(true, true);
    }

    _fetch(shouldReturnJSON, shouldReturnPromise){
        let promise;
        try {
            promise = (shouldReturnJSON ? $.getJSON : $.get)(this.url, (response) => {
                this.successCallbacks.forEach(callback => callback(response));
                if (this.successCallbacks.size === 0) {
                    this.logInfo("Fetched successfully without callback");
                }
                this.logDebug("Fetched successfully");
            }).fail((jqxhr, textStatus, error) => {
                this.errorCallbacks.forEach(callback => callback(textStatus, error));
                if (this.errorCallbacks.size === 0) {
                    this.logError("Error on fetch [" + textStatus + "]", error);
                }
            }).always(() => {
                this.alwaysCallbacks.forEach(callback => callback());
            });
        } catch (e){
            this.logError("Could not fetch", e);
        }
        return shouldReturnPromise?promise:this;
    }

    /**
     * Add a callback that executes on fetch success
     * @param callback {function} a function that takes the returned data as param
     * @return {Fetcher}
     */
    success(callback){
        if (callback) {
            this.successCallbacks.add(callback);
        }
        return this;
    }

    /**
     * Add a callback that executes on fetch error
     * @param callback {function} a function that takes a textStatus string and the thrown error
     * @return {Fetcher}
     */
    error(callback){
        if (callback) {
            this.errorCallbacks.add(callback);
        }
        return this;
    }

    /**
     * Add a callback that executes on fetch success or error
     * @param callback {function} a function that takes no params
     * @return {Fetcher}
     */
    always(callback){
        if (callback) {
            this.alwaysCallbacks.add(callback);
        }
        return this;
    }

}

export {Fetcher, FetcherFactory};